import angular from 'angular';
import { cloneDeep } from 'lodash';
import '../resources/organization-information-screen';

const module = angular.module('whyline.services.organization-information-screen', [
  'whyline.resources.organization-information-screen'
]);

let OrganizationInformationScreen;
// const socketEvents = {
//   create: 'organization-information-screen:created',
//   update: 'organization-information-screen:updated',
//   deleted: 'organization-information-screen:deleted',
// };

class OrganizationInformationScreenService {
  static $inject = ['OrganizationInformationScreen'];

  constructor(injectedOrganizationInformationScreen) {
    OrganizationInformationScreen = injectedOrganizationInformationScreen;
  }

  Create(data) {
    const newOrganizationInformationScreen = new OrganizationInformationScreen(data);
    return OrganizationInformationScreen.Save(newOrganizationInformationScreen);
  }

  GetAll() {
    return OrganizationInformationScreen.FetchAll();
  }

  GetAllAsPromise() {
    return OrganizationInformationScreen.FetchAll({
      promise: true
    });
  }

  GetAllFromServer() {
    return OrganizationInformationScreen.FetchAll({
      force: true
    });
  }

  GetAllAsPromiseFromServer() {
    return OrganizationInformationScreen.FetchAll({
      promise: true,
      force: true
    });
  }

  GetOne(organizationInformationScreenId) {
    return OrganizationInformationScreen.FindById(organizationInformationScreenId);
  }

  GetOneAsPromise(organizationInformationScreenId) {
    return OrganizationInformationScreen.FindById(organizationInformationScreenId, {
      promise: true
    });
  }

  GetOneFromServer(organizationInformationScreenId) {
    return OrganizationInformationScreen.FindById(organizationInformationScreenId, {
      force: true
    });
  }

  GetOneAsPromiseFromServer(organizationInformationScreenId) {
    return OrganizationInformationScreen.FindById(organizationInformationScreenId, {
      promise: true,
      force: true
    });
  }

  Copy(appointment) {
    const copy = cloneDeep(appointment);
    return new OrganizationInformationScreen(copy);
  }

  Update(organizationInformationScreen) {
    return OrganizationInformationScreen.Save(organizationInformationScreen);
  }

  UpdatePartial(options) {
    return OrganizationInformationScreen.SavePartial(options);
  }

  Switch(organizationInformationScreen, isActive, isActiveInPlaces) {
    return organizationInformationScreen.enable(isActive, isActiveInPlaces);
  }
}

module.exports = module.service('OrganizationInformationScreenService', OrganizationInformationScreenService);
